import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import TimeAgo from "react-timeago"
import { Alert, Col, Input, Modal, ModalBody, Row } from "reactstrap"
import SkeletonHandler from "../../Skeleton/SkeletonHandler"
import debounce from "lodash.debounce"
import { get } from "api/axios"
import endpoints from "api/endpoints"
import { Link } from "react-router-dom"
import { error } from "toastr"
const ModelSearch = ({ show, onCloseClick }) => {
  const [search, setSearch] = useState("")
  const [videoData, setVideoData] = useState([])
  const [loading, setLoading] = useState(false)
  const [errorMgs, setErrorMgs] = useState("")
  const [searched, setSearched] = useState(false)

  useEffect(() => {
    setSearch("")
    setVideoData({})
    setLoading(false)
    setErrorMgs("")
    setSearched(false)
  }, [show])
  const delayedHandleChange = () => {
    if (search !== "" && search !== undefined) {
      getFetch(search)
      setErrorMgs("")
    } else {
      setErrorMgs("Please enter a search")
    }
  }

  const getFetch = async text => {
    setLoading(true)
    const trimmedText = text.trim()
    if (trimmedText.length === 0) {
      return
    }

    try {
      const resp = await get(
        `${endpoints.getVideos}?&filter=search&search=${trimmedText}`
      )
      if (resp?.data?.success) {
        setLoading(false)
        setVideoData(resp?.data?.data)

        if (resp?.data?.data.length <= 0) {
          setSearched(true)
        } else {
          setSearched(false)
        }
      } else {
        setLoading(false)
      }
    } catch (e) {
      setLoading(false)
      console.error(e)
    }
  }

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-2 px-md-5">
        <div>
          <h3>Search Video By Their Title:</h3>
          <div className="serachBarPx d-flex align-items-center ">
            <Input
              value={search}
              className="border-0 serachBarPxInput"
              placeholder="Search video by title"
              onChange={e => {
                setSearch(e.target.value)
              }}
            />
            <span
              className="serachBarPxIcon d-flex align-items-center justify-content-center"
              onClick={e => {
                delayedHandleChange()
              }}
            >
              <p className="fs-16 m-0 fw-bolder">
                Search <i className="fa fa-search " />
              </p>
            </span>
          </div>
          {errorMgs != "" && (
            <p className="m-0 text-danger fs-14">{errorMgs}</p>
          )}
        </div>
        {loading && (
          <div className="pt-3">
            <p className="fs-18 fw-bloder m-0">Searching ..</p>
            <SkeletonHandler />
          </div>
        )}
        {loading != true && videoData?.length > 0 && (
          <div className="pt-3">
            <p className="fs-18 fw-bloder m-0">Found Videos:</p>
            {videoData.map(card => (
              <div key={card.id}>
                <div className="row align-items-center">
                  <div className="image-container position-relative col-5">
                    <Link
                      to={`/videodetail/${card?._id}`}
                      onClick={e => {
                        onCloseClick()
                      }}
                    >
                      <img
                        src={`${process.env.REACT_APP_S3_BUCKET}${card?.thumbnail}`}
                        alt=""
                        className="w-100 rounded-1 object-fit-cover"
                        height={"100px"}
                      />
                    </Link>
                  </div>
                  <div className="col-7">
                    <h3 className="font-size-14 fw-medium text-darkcolor">
                      <Link
                        to={`/videodetail/${card?._id}`}
                        onClick={e => {
                          onCloseClick()
                        }}
                      >
                        {card?.title}
                      </Link>
                    </h3>
                    <p className="font-size-12 text-secondary p-0 m-0">
                      {/* <TimeAgo date={card.updatedAt} /> */}
                      {card?.updatedAt &&
                        new Date(card.updatedAt)?.toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                    </p>
                  </div>
                </div>
                {videoData?.length == 1 ? (
                  ""
                ) : (
                  <hr className="p-0 m-0 mt-1 text-secondary" />
                )}
              </div>
            ))}
          </div>
        )}
        {searched == true && (
          <div className="pt-4">
            <Alert color="danger">No Video Found! Please try again.</Alert>
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

ModelSearch.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
}

export default ModelSearch
